<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    chartData: {
      type: Object,
      default: null
    },
    showLegend: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    chartData () {
      this.render()
    },
    showLegend () {
      this.render()
    }
  },
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          onClick: () => {},
          labels: {
            boxWidth: 12,
            usePointStyle: true
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
              fontSize: 10
            },
            gridLines: {
              color: '#E5E7EB'
            }
          }],
          xAxes: [{
            ticks: {
              fontSize: 10,
              autoSkip: true,
              maxTicksLimit: 12
            },
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        hover: {
          mode: 'nearest',
          intersect: false
        }
      }
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    render () {
      if (!this.chartData) {
        return
      }

      this.renderChart(this.chartData, {
        ...this.options,
        legend: {
          ...this.options.legend,
          display: this.showLegend
        }
      })
    }
  }
}
</script>
